{
  "types": {
    "Instruction": [
      { "name": "salt", "type": "uint256" },
      { "name": "maxExecutions", "type": "uint256" },
      { "name": "action", "type": "address" },
      { "name": "transferERC20", "type": "TransferERC20" }
    ],
    "TransferERC20": [
      { "name": "token", "type": "address" },
      { "name": "target", "type": "address" },
      { "name": "value", "type": "uint256" },
      { "name": "schedule", "type": "Schedule" },
      { "name": "fee", "type": "Fee" }
    ],
    "Schedule": [
      { "name": "startAt", "type": "uint256" },
      { "name": "startBy", "type": "uint256" },
      { "name": "interval", "type": "uint256" },
      { "name": "timeout", "type": "uint256" }
    ],
    "Fee": [
      { "name": "token", "type": "address" },
      { "name": "maxBaseFeePerGas", "type": "uint256" },
      { "name": "maxPriorityFeePerGas", "type": "uint256" },
      { "name": "executionFee", "type": "uint256" }
    ]
  }
}
